import * as React from "react";
import { useQueryClient } from "react-query";

import { Syllabus, Clazz } from "../../types";
import { TextInput } from "../../styled-component";
import CRUDModal, { CRUDModalProps } from "../../common/components/CRUDModal";
import SyllabusService from "../../services/Syllabus";
import { makeQueryKey } from "../../hooks/clazzes/useListClazzSyllabi";

import Text from "../common/Text";
import { pick } from "lodash";

const DEFAULT_VALUES = { name: "" };

export interface CreateOrUpdateSyllabusProps
  extends Omit<CRUDModalProps<Syllabus>, "service"> {
  clazzId?: Clazz["id"];
}

const service = new SyllabusService();

function CreateOrUpdateSyllabus({
  clazzId,
  ...rest
}: CreateOrUpdateSyllabusProps) {
  const getButtonTitle: CRUDModalProps<Syllabus>["getButtonTitle"] = (
    _video,
    { isNew } = {}
  ) => (isNew ? "Create Syllabus" : "Edit Syllabus");

  const getModalTitle: CRUDModalProps<Syllabus>["getModalTitle"] = (
    syllabus,
    { isNew } = {}
  ) => (isNew ? "New Syllabus" : syllabus?.name || "|");

  const getDefaultValues: CRUDModalProps<Syllabus>["getDefaultValues"] = (
    syllabus
  ) => {
    if (syllabus) {
      return { ...pick(syllabus, "id", "name"), clazz: syllabus.clazz?.id };
    }

    return { ...DEFAULT_VALUES, clazz: clazzId };
  };

  const queryClient = useQueryClient();

  return (
    <CRUDModal<Syllabus>
      {...rest}
      onSuccess={(syllabus) => {
        queryClient.invalidateQueries(
          makeQueryKey(clazzId || syllabus.clazz?.id)
        );
      }}
      getButtonTitle={getButtonTitle}
      getModalTitle={getModalTitle}
      getDefaultValues={getDefaultValues}
      service={service}
      renderForm={({
        setValue,
        watch,
        isNew,
        isDisabled,
        reset,
        defaultValues,
      }) => {
        const name = watch("name");

        React.useEffect(() => {
          reset(defaultValues);
        }, [clazzId]);

        return (
          <>
            <Text.Label>Name</Text.Label>
            <TextInput
              autoFocus={isNew}
              editable={!isDisabled}
              onChangeText={(nextName) => setValue("name", nextName)}
              value={name}
            />
          </>
        );
      }}
    />
  );
}

export default CreateOrUpdateSyllabus;
